import { SafeResourceUrl } from '@angular/platform-browser';

export enum AvatarSize {
  Mini = 'mini',
  Small = 'small',
  Medium = 'medium',
  Big = 'big',
}

export enum AvatarVariant {
  Circle = 'circle',
  Square = 'square',
}

export interface AvatarConfig {
  variant: AvatarVariant;
  size: AvatarSize;
  name?: string;
  alt?: string;
  src?: string | SafeResourceUrl | null;
  classList?: string[];
  disableHovering?: boolean;
}
